import { evisearchApiRoot } from './root';

export const api = evisearchApiRoot;
